import React, { useState } from "react";
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    ListItemText,
    Typography,
} from "@mui/material";
import moment from "moment";
import { Link } from 'react-router-dom'
import { useHistory, useParams } from "react-router";
import { Block, BorderColor, CheckCircle, Delete, KeyboardBackspace } from "@mui/icons-material";
import StatusLayout from "components/Status";
import SmallModal from "components/Modal/SmallModel";
import AddModal from "./AddModal";
import DeleteDialog from "helpers/DeleteDialog";
import { meetingType } from "../Meetings/CreateMeeting/Create";
import { DonutLarge } from "@material-ui/icons";
import WorklogManager from "../../views/admin/WorklogManager";

const ActionDetails = (props) => {
    const {
        info, setLoading, loading, onSubmit, GetEmployees, resources, loggedUser,systemSettings
    } = props;
    const [type, setType] = useState({})
    const { id } = useParams();

    const history = useHistory();
    const [logOpen, setLogOpen] = React.useState(false);
    const [confirm, setConfirm] = useState(false);
    const [editInfo, setEditInfo] = useState({})
    const [select, setSelect] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);


    const days = moment(info?.endDate).diff(moment(), 'days');

    // const duration =

    //         (list[index]?.paidAmount * 100) / list[index]?.budgetAmount;
    //     amount = Math.round(amount);
    return (
        <div>

            <WorklogManager actionTrackId={id} open={logOpen} setOpen={() => setLogOpen(false)} />
            <Card className="mb-3">
                {/* <CardHeader
                    title={
                        <>
                            <span className="text-capitalize">
                                Action Details:<StatusLayout status={info?.status} />
                            </span>

                        </>
                    }
                    titleTypographyProps={{ variant: "h6" }}
                    action={<span >Days left:{` ${days} day(s)`}</span>}

                /> */}
                <CardHeader
                    title={
                        <>
                            <span className="text-capitalize">
                                Action Details:<StatusLayout status={info?.status} />
                            </span>
                        </>
                    }
                    titleTypographyProps={{ variant: "h6" }}
                    action={
                        <span>
                            {days > 1
                                ? `Days left: ${days} day(s)`
                                : days === 0
                                    ? "Days left: Today"
                                    : "Days left: Completed"}
                        </span>
                    }
                />
                <CardContent>
                    <div className={"row mt-3 grid grid-cols-3 gap-4"}>
                        <div className={"col-md-4"}>
                            <h3 className="text-capitalize fw-bold mb-2 font-bold">
                                Item name
                            </h3>
                            <div>
                                <Typography variant={"body2"}>
                                    {info?.name}
                                </Typography>
                            </div>
                        </div>
                        <div className={"col-md-4"}>
                            <h3 className="text-capitalize fw-bold mb-2 font-bold">
                                Start Date
                            </h3>
                            <div>
                                <Typography variant={"body2"}>
                                    {moment(info?.startDate).format("DD/MM/yyyy")}
                                </Typography>
                            </div>
                        </div>
                        <div className={"col-md-4"}>
                            <h3 className="text-capitalize fw-bold font-bold">
                                End Date
                            </h3>
                            <div>
                                <Typography variant={"body2"}>
                                    {moment(info?.endDate).format("DD/MM/yyyy")}
                                </Typography>
                            </div>
                        </div>
                        <div className={"col-md-4"}>
                            <h3 className="text-capitalize fw-bold font-bold">
                                Originate From
                            </h3>
                            <div>
                                <Typography variant={"body2"}>
                                    {meetingType?.find(v => v.value == info?.type)?.label}
                                </Typography>
                            </div>
                        </div>
                    </div>

                    <div className={"row mt-3 grid grid-cols-1 gap-4"}>

                        <div className={"col-md-12"}>
                            <h3 className="text-capitalize fw-bold font-bold mb-2">
                                Description
                            </h3>
                            <div dangerouslySetInnerHTML={{ __html: info?.description }} />
                        </div>
                        {info?.minutesId ?
                            <div className={"col-md-12"}>
                                <h3 className="text-capitalize fw-bold font-bold mb-2">
                                    Linked Meeting
                                </h3>
                                <Link to={`/admin/minutes/details/${info?.minutesId}`}>
                                    <em className="text-sky-400">click here to view</em>
                                </Link>
                            </div>
                            : null}
                    </div>
                    <div className={"row mt-3 grid grid-cols-3 gap-4"}>
                        <div className={"col-md-4"}>
                            <h3 className="text-capitalize fw-bold mb-2 font-bold">
                                Initiator
                            </h3>
                            <div className="bg-">
                                <ListItemText primary={info?.initiated?.names} secondary={info?.initiated?.category} />

                            </div>
                        </div>
                        <div className={"col-md-4"}>
                            <h3 className="text-capitalize fw-bold mb-2 font-bold">
                                Assigned to
                            </h3>
                            <div>
                                <ListItemText primary={info?.responsible?.names} secondary={info?.responsible?.category} />

                            </div>
                        </div>
                        <div className={"col-md-4 bg-green-400"}>
                            <h3 className="text-capitalize fw-bold mb-2 font-bold">
                                Report to
                            </h3>
                            <div>
                                <ListItemText primary={info?.report?.names} secondary={info?.report?.category} />
                            </div>
                        </div>
                    </div>
                </CardContent>
                <CardActions className={"flex justify-end"}>
                    <Button size="small" onClick={() => history.goBack()} startIcon={<KeyboardBackspace />}>Go Back</Button>
                    <Button size="small" onClick={() => setLogOpen(true)} startIcon={<DonutLarge />}>Worklogs</Button>

                    <Button
                        style={{ color: "#336767" }}
                        color="info"
                        size="small"
                        onClick={() => {
                            setSelect(true)
                            setEditInfo({ ...info, endDate: moment(info?.endDate).format('YYYY-MM-DD'), startDate: moment(info?.startDate).format('YYYY-MM-DD') })
                        }}
                        startIcon={<BorderColor />}  >{'Edit'}</Button>
                    {info?.status === 'completed' ? null : <>
                        <Button size="small" color="error" onClick={() => setOpenDelete(true)} startIcon={<Delete />}>Delete</Button>

                        <Button
                            size="small"
                            onClick={() => {

                                setType({ status: info?.status === 'on hold' ? 'in progress' : 'on hold', title: `Are you sure you want to ${info?.status === 'on hold' ? 'to resume' : 'suspend'} this action?` });
                                setConfirm(true)
                            }}
                            startIcon={<Block />} variant="text" color="secondary" >{info?.status === 'on hold' ? 'Resume' : 'Suspend'}</Button>
                        {/* //mark as complete */}
                        <Button
                            size="small"
                            onClick={() => {

                                setType({ status: 'completed', title: "Are you sure you want to complete this action?" });
                                setConfirm(true)
                            }}
                            startIcon={<CheckCircle />} color="success" >Complete</Button>
                    </>}
                </CardActions>
            </Card>

            <SmallModal
                select={confirm}
                setSelect={setConfirm}
                confirm={() => {
                    setLoading(true);
                    return onSubmit({ status: type.status });
                }}>
                <i className="fa fa-check-circle fa-4x text-green-500 me-2" />
                <span>{type.title}</span>
            </SmallModal>
            <DeleteDialog open={openDelete} setOpen={setOpenDelete}
                url={`/api/meeting-action/${info.id}`} onSuccess={() => { history.push('/admin/action') }} />

            <AddModal setType={setType}
                setInfo={setEditInfo}
                info={editInfo}
                type={type}
                // setListOfAction={setListOfAction}
                resources={resources}
                GetEmployees={GetEmployees}
                setSelect={setSelect}
                loggedUser={loggedUser}
                select={select}
                loading={loading}
                needDirectSubmit={true}
                onSubmit={onSubmit}
                systemSettings={systemSettings}
            />
        </div>
    );
};
export default ActionDetails;
